// extracted by mini-css-extract-plugin
export var questionBox = "_7f-0";